const isNewPasswordValid = (identityString: string): boolean => {
  return /^[a-zA-Z0-9_]+$/.test(identityString);
};

export default isNewPasswordValid;
